"use client";

;
import { use } from "react";
import { Card } from "@/components/ui/card";
import { paymentLinks } from "../../constants/paymentLinks";
type PageProps = {
  params: Promise<{
    locale: string;
    institutionSlug: string;
    formSlug: string;
  }>;
};
export default function Page(props: PageProps) {
  const params = use(props.params);
  const formSlug = params.formSlug;
  const paymentUrl = paymentLinks.find(item => item.slug === formSlug)?.url;
  if (!paymentUrl) {
    return null;
  }
  return <Card className="h-auto overflow-hidden mobile:h-screen" data-sentry-element="Card" data-sentry-component="Page" data-sentry-source-file="page.tsx">
      <iframe src={paymentUrl} width="100%" className="m-0 h-[3200px] border-0 p-0 mobile:h-screen"></iframe>
    </Card>;
}